<template>
  <div>
    <div class="tw-flex tw-flex-start tw-justify-between">
      <p
        class="tw-mx-4 tw-block tw-text-eko-orange tw-mt-8 tw-font-bold tw-text-2xl"
      >
        Projects Created
      </p>
    </div>
    <div v-if="projects.length > 0" class="tw-flex tw-flex-wrap tw--mt-2">
      <div
        class="tw-w-full md:tw-w-1/4 tw-p-2"
        v-for="project in projects"
        :key="project._id"
      >
        <ProjectCard :project="project" />
      </div>
    </div>
    <div v-else>
      <p>No projects created yet</p>
    </div>
  </div>
</template>

<script>
import ProjectCard from "@/components/Admin/SingleProject.vue";
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      projects: [],
      loading: false,
      errors: {},
      disabled: false,
      user: {},
      token: ""
    };
  },
  components: {
    ProjectCard,
  },
  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    this.fetchProjects();
  },
  methods: {
    fetchProjects() {
      axios
        .get(`${this.$baseUrl}/admin/project/getAll`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.projects = response.data.project;
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped>
.add-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 20px;
  padding-bottom: 30px;
  color: white;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  font-size: 36px;
}
</style>
